import { Alert, Box, Chip, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { adminGetQuizResults } from '../../api/adminApi';
import { useAdminAuth } from '../../Context/AdminAuthContext';

const statusLabel = (s: number) => ({ 0: 'Not Started', 1: 'In Progress', 2: 'Completed' }[s] ?? 'Unknown');

export default function AdminQuizResults() {
    const { token } = useAdminAuth();
    const [results, setResults] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!token) return;
        adminGetQuizResults(token)
            .then(setResults)
            .catch(e => setError(e.message))
            .finally(() => setLoading(false));
    }, [token]);

    return (
        <Box>
            <Typography variant="h5" fontWeight={700} mb={3}>Quiz Results</Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {loading ? <CircularProgress /> : (
                <Table size="small" sx={{ bgcolor: 'white', borderRadius: 1 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Broker</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Quiz</TableCell>
                            <TableCell>Score</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Result</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results.map((r, i) => (
                            <TableRow key={i} hover>
                                <TableCell>{r.brokerName}</TableCell>
                                <TableCell>{r.brokerEmail}</TableCell>
                                <TableCell>{r.quizTitle}</TableCell>
                                <TableCell>{r.score}%</TableCell>
                                <TableCell>{statusLabel(r.status)}</TableCell>
                                <TableCell>
                                    <Chip label={r.passed ? 'Pass' : 'Fail'} color={r.passed ? 'success' : 'error'} size="small" />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </Box>
    );
}
